/** Resolve download filenames for Smart Resume / CV exports. */

export function getCandidateFullName(profile = {}) {
  const parts = [profile.firstName, profile.middleName, profile.lastName]
    .map((part) => (part && String(part).trim()) || '')
    .filter(Boolean);

  if (parts.length > 0) {
    return parts.join(' ');
  }

  const fallback = profile.name || profile.fullName;
  return (fallback && String(fallback).trim()) || '';
}

export function sanitizeDownloadBasename(name, fallback = 'Resume') {
  const cleaned = String(name || '')
    .trim()
    .replace(/[<>:"/\\|?*\u0000-\u001f]/g, '')
    .replace(/\s+/g, ' ');
  return cleaned || fallback;
}

export function buildSmartResumePdfFilename(profile) {
  const base = sanitizeDownloadBasename(getCandidateFullName(profile), 'Resume');
  return `${base}.pdf`;
}

export function buildCvZipFilename(profile) {
  const base = sanitizeDownloadBasename(getCandidateFullName(profile), 'Candidate');
  return `${base} CV.zip`;
}

export function getFilenameFromContentDisposition(header) {
  if (!header) return null;

  const utf8Match = /filename\*=UTF-8''([^;]+)/i.exec(header);
  if (utf8Match) {
    try {
      return decodeURIComponent(utf8Match[1].trim());
    } catch {
      // fall through
    }
  }

  const quotedMatch = /filename="([^"]+)"/i.exec(header);
  if (quotedMatch) {
    return quotedMatch[1].trim();
  }

  const plainMatch = /filename=([^;\s]+)/i.exec(header);
  return plainMatch ? plainMatch[1].trim() : null;
}

/**
 * @param {'pdf'|'zip'} kind - Expected download type when falling back to profile name
 */
export function resolveDownloadFilename(response, profile, fallbackName, kind = 'pdf') {
  const fromHeader = getFilenameFromContentDisposition(
    response?.headers?.get?.('Content-Disposition')
  );
  if (fromHeader) return fromHeader;

  if (profile && getCandidateFullName(profile)) {
    return kind === 'zip' ? buildCvZipFilename(profile) : buildSmartResumePdfFilename(profile);
  }

  return fallbackName;
}
